/* TB V9.26 Newsletter: eigene Formulare statt Klaviyo-Embeds (sections/tb-newsletter, sections/tb-nl-popup, snippets/tb-nl-form).
   Senden: Klaviyo Client-API POST /client/subscriptions (öffentlicher Schlüssel). Antwort 202 = angenommen.
   Double-Opt-in-Liste → Klaviyo schickt die Bestätigungsmail; nach Bestätigung startet der Listen-Flow (Gutschein).
   Pop-up: Wartezeit + Scrolltiefe, Sperre nach Anmeldung (für immer) bzw. Wegklicken (X Tage) in localStorage. */
(function(){
  if(window.__tbNl)return;window.__tbNl=1;
  var LS={g:function(k){try{return localStorage.getItem(k)}catch(e){return null}},s:function(k,v){try{localStorage.setItem(k,v)}catch(e){}}};
  var K_DONE='tb_nl_done',K_X='tb_nlp_x',html=document.documentElement;
  var RX=/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function knownToKlaviyo(){
    try{var m=document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);if(!m)return false;
      var o=JSON.parse(atob(decodeURIComponent(m[1])));return !!(o&&(o.$exchange_id||o.$email||o.email))}catch(e){return false}
  }

  function send(f,email){
    var body={data:{type:'subscription',attributes:{custom_source:f.getAttribute('data-src')||'TB',profile:{data:{type:'profile',attributes:{email:email}}}},
      relationships:{list:{data:{type:'list',id:f.getAttribute('data-list')}}}}};
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(f.getAttribute('data-cid')),{
      method:'POST',headers:{'content-type':'application/vnd.api+json',accept:'application/vnd.api+json',revision:'2024-10-15'},body:JSON.stringify(body)
    }).then(function(r){if(r.status===202||r.ok)return true;var e=new Error('http');e.status=r.status;throw e});
  }

  function setErr(f,msg){var p=f.querySelector('[data-tb-nl-err]'),i=f.querySelector('input[type=email]');if(!p)return;
    p.textContent=msg||'';p.hidden=!msg;if(i){if(msg)i.setAttribute('aria-invalid','true');else i.removeAttribute('aria-invalid')}}

  function done(f,email){
    LS.s(K_DONE,'1');
    var ok=f.nextElementSibling;f.hidden=true;if(ok&&ok.hasAttribute('data-tb-nl-ok')){ok.hidden=false;try{ok.focus({preventScroll:true})}catch(e){}}
    var host=f.closest('.tb-nl,.tb-nlp');if(host)host.classList.add('is-done');
    try{if(window.klaviyo&&typeof klaviyo.identify==='function')klaviyo.identify({email:email})}catch(e){}
    try{(window.dataLayer=window.dataLayer||[]).push({event:'tb_newsletter_signup',tb_nl_source:f.getAttribute('data-src')||''})}catch(e){}
    try{document.dispatchEvent(new CustomEvent('tb:nl-signup',{detail:{source:f.getAttribute('data-src')}}))}catch(e){}
  }

  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches||!f.matches('form[data-tb-nl]'))return;e.preventDefault();
    if(f.__busy)return;
    var i=f.querySelector('input[type=email]'),hp=f.querySelector('input[name=website]'),email=(i&&i.value||'').trim();
    if(hp&&hp.value){done(f,email);return}
    if(!RX.test(email)){setErr(f,f.getAttribute('data-e1'));if(i)i.focus();return}
    setErr(f,'');f.__busy=1;f.classList.add('is-busy');
    var lbl=f.querySelector('[data-tb-nl-lbl]'),old=lbl?lbl.textContent:'';if(lbl)lbl.textContent=f.getAttribute('data-busy')||old;
    var btn=f.querySelector('button[type=submit]');if(btn)btn.disabled=true;
    send(f,email).then(function(){done(f,email)}).catch(function(err){
      setErr(f,err&&err.status===400?f.getAttribute('data-e1'):f.getAttribute('data-e2'));
    }).then(function(){f.__busy=0;f.classList.remove('is-busy');if(lbl)lbl.textContent=old;if(btn)btn.disabled=false});
  });
  document.addEventListener('input',function(e){var f=e.target.form;if(f&&f.hasAttribute&&f.hasAttribute('data-tb-nl')&&!f.querySelector('[data-tb-nl-err]').hidden)setErr(f,'')});

  /* ---------- Pop-up ---------- */
  function initPop(dlg){
    if(!dlg||dlg.__tb)return;dlg.__tb=1;
    var design=!!(window.Shopify&&Shopify.designMode),mode=dlg.getAttribute('data-nl-mode');
    function open(){if(dlg.open||!dlg.isConnected)return;if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','');html.classList.add('tb-sheet-open')}
    function close(){if(dlg.close&&dlg.open)dlg.close();else dlg.removeAttribute('open');html.classList.remove('tb-sheet-open')}
    dlg.addEventListener('click',function(e){if(e.target===dlg||e.target.closest('[data-tb-sheet-close]'))close()});
    dlg.addEventListener('close',function(){html.classList.remove('tb-sheet-open');if(!design&&!dlg.classList.contains('is-done'))LS.s(K_X,String(Date.now()))});
    if(design){
      document.addEventListener('shopify:section:select',function(e){if(e.detail&&e.detail.sectionId===dlg.getAttribute('data-sid'))open()});
      document.addEventListener('shopify:section:deselect',function(e){if(e.detail&&e.detail.sectionId===dlg.getAttribute('data-sid'))close()});
      return;
    }
    if(mode==='off')return;
    if(mode==='mobile'&&!(window.matchMedia&&matchMedia('(max-width: 749px)').matches))return;
    if(LS.g(K_DONE)==='1')return;
    var x=+LS.g(K_X)||0,days=+dlg.getAttribute('data-nl-days')||14;if(x&&Date.now()-x<days*864e5)return;
    if(knownToKlaviyo())return;
    var delay=(+dlg.getAttribute('data-nl-delay')||0)*1000,need=(+dlg.getAttribute('data-nl-scroll')||0)/100,timeOk=false,scrollOk=need<=0,fired=false;
    function depth(){var h=document.documentElement.scrollHeight-innerHeight;return h>0?scrollY/h:1}
    function busy(){return !!document.querySelector('dialog[open]')||html.classList.contains('m2a')||html.classList.contains('m6pn-open')||html.classList.contains('tb-sheet-open')||(document.activeElement&&/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName))}
    function tryOpen(){if(fired||!timeOk||!scrollOk)return;if(busy()){setTimeout(tryOpen,4000);return}fired=true;removeEventListener('scroll',onScroll);open()}
    function onScroll(){if(!scrollOk&&depth()>=need){scrollOk=true;tryOpen()}}
    addEventListener('scroll',onScroll,{passive:true});
    setTimeout(function(){timeOk=true;tryOpen()},delay);
  }
  function init(root){[].forEach.call((root||document).querySelectorAll('dialog[data-tb-nlp]'),initPop)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init()});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
